module.exports = __webpack_public_path__ + "public/images/calendar-request.d366b93236809544a85cf8e6d074b206.svg";